import * as yup from 'yup';

export const schema = yup
  .object({
    des_ajuste: yup.string().trim().required(),
  })
  .required();
